import React from "react";

// WholesaleDai DS Button (Claude Design "WholesaleDai Platform" components/Button).
// Replaces the duplicated Tailwind button className recipes across auth/profile forms.
// Filled actions use brand-600 with darken-on-hover (brand-700) — never invert to white,
// never white text on brand-500 (fails AA).

const VARIANTS = {
	primary:
		"bg-brand-600 text-white border border-transparent hover:bg-brand-700",
	secondary:
		"bg-white text-brand-600 border border-gray-200 hover:bg-brand-50 hover:border-brand-600",
	ghost:
		"bg-transparent text-gray-600 border border-transparent hover:bg-gray-100 hover:text-gray-900",
	danger:
		"bg-red-600 text-white border border-transparent hover:bg-red-700",
};

const SIZES = {
	sm: "h-8 px-3 text-[13px]",
	md: "h-10 px-[18px] text-sm",
	lg: "h-12 px-6 text-[15px]",
};

const Button = ({
	variant = "primary",
	size = "md",
	fullWidth = false,
	type = "button",
	disabled = false,
	className = "",
	children,
	...rest
}) => {
	return (
		<button
			type={type}
			disabled={disabled}
			className={`inline-flex items-center justify-center gap-2 font-semibold rounded-md cursor-pointer transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 disabled:opacity-55 disabled:cursor-not-allowed ${
				VARIANTS[variant] || VARIANTS.primary
			} ${SIZES[size] || SIZES.md} ${fullWidth ? "w-full" : ""} ${className}`}
			{...rest}
		>
			{children}
		</button>
	);
};

export default Button;
